import { render, staticRenderFns } from "./PrivacyPoliciesContent.vue?vue&type=template&id=d8b4bd4e&scoped=true"
import script from "./PrivacyPoliciesContent.vue?vue&type=script&lang=js"
export * from "./PrivacyPoliciesContent.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPoliciesContent.vue?vue&type=style&index=0&id=d8b4bd4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b4bd4e",
  null
  
)

export default component.exports